---
title: "Introduction"
description: "What AI Apps is and why it exists."
---

# Introduction

AI Apps is a TypeScript framework for building production-ready AI applications. It provides the building blocks you need to create structured, reliable AI workflows.

## Why AI Apps?

...

## Key Concepts

- **Prompts** -- Multi...
- **Tools** -- Tools...
- **Resources** -- Built-in...
- **Evaluation** -- Test and measure your AI application's behavior

## Next Steps

Head to the [Quickstart](/docs/quickstart) to build your first AI app in under 5 minutes.
